'use client';

import { DynamicUserProfile } from '@dynamic-labs/sdk-react-core';
import React, { ReactNode } from 'react';

import { Dapp } from '@repo/dapp-kit';
import { tw } from '@repo/ui';

interface LayoutWrapperProps {
  children: ReactNode;
}

export const LayoutWrapper: React.FC<LayoutWrapperProps> = ({ children }) => {
  return (
    <Dapp
      chains={['evm', 'sol']}
      enableAbly
    >
      <div id='modal' />
      <div
        className={tw(
          'max-h-screen-safe selection:bg-[#0ad775]',
          'safari:bg-black min-h-screen bg-black',
        )}
      >
        {children}
        <DynamicUserProfile />
      </div>
    </Dapp>
  );
};
